import {createAction} from 'web-app/util/redux/famly-app-helpers';

import createGlobalEventActions from './helpers/create-actions';

export const {updateError, updateSuccess, updateInfo, updateStatus, clearStatus} =
    createGlobalEventActions(createAction);
